import MainContainer from '@/components/MainContainer'
import { SubNav } from '@/components/SubNav'
import { ProvideNote } from 'contexts/note'
import HomeLayout from './HomeLayout'

type Props = React.PropsWithChildren & {
  showNav?: boolean
  title?: string
  showSubNav?: boolean
  description?: string
  image?: string
  width?: number
  note_id: string
}

export default function NoteLayout({
  width,
  note_id,
  children,
  showSubNav = true,
  ...args
}: Props) {
  return (
    <HomeLayout requireAuth={true} {...args}>
      <ProvideNote note_id={note_id}>
        {showSubNav ? <SubNav /> : null}
        <MainContainer width={width}>{children}</MainContainer>
      </ProvideNote>
    </HomeLayout>
  )
}
